import { __assign } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { Menu as MenuSmallIcon } from '../../../internal/icons/small/Menu';
import { makeStyles, createStyles } from '../../styles';
import { useBreadcrumbsContext } from '../Breadcrumbs.context';
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        button: {
            minWidth: 'max-content',
            minHeight: 'max-content',
            padding: '4px',
            borderRadius: '2px',
            border: '1px solid transparent',
            '&:hover': {
                border: "1px solid ".concat(theme.palette.background.b8),
                backgroundColor: theme.palette.background.b3,
                '& svg': {
                    color: theme.palette.background.b9,
                },
            },
            '&[aria-expanded="true"]': {
                border: "1px solid ".concat(theme.palette.brand.main),
                backgroundColor: theme.palette.type === 'light' ? theme.palette.brand.light : theme.palette.brandAlt.main,
                '& svg': {
                    color: theme.palette.type === 'light' ? theme.palette.brand.main : theme.palette.text.primary,
                },
            },
        },
    });
});
export var BreadcrumbsMenu = function (props) {
    var menuId = props.menuId, expandText = props.menuButtonLabel, breadcrumbsMenuItems = props.breadcrumbsMenuItems;
    var classes = useStyles();
    var _a = useBreadcrumbsContext(), components = _a.components, MenuProps = _a.MenuProps, MenuItemProps = _a.MenuItemProps, ButtonProps = _a.ButtonProps;
    var Menu = components.Menu, MenuItem = components.MenuItem, Button = components.Button;
    var buttonRef = React.useRef(null);
    var _b = React.useReducer(function (isMenuOpen) { return !isMenuOpen; }, false), isMenuOpen = _b[0], toggleIsMenuOpen = _b[1];
    if (breadcrumbsMenuItems.length === 0) {
        return null;
    }
    var handleOnClick = function (item) {
        var _a;
        toggleIsMenuOpen();
        (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, __assign({ id: "button-".concat(menuId), onClick: toggleIsMenuOpen }, ButtonProps, { className: clsx(classes.button, ButtonProps === null || ButtonProps === void 0 ? void 0 : ButtonProps.className), "aria-label": expandText, "aria-controls": isMenuOpen ? menuId : undefined, "aria-expanded": isMenuOpen, "aria-haspopup": "menu", ref: buttonRef }),
            React.createElement(MenuSmallIcon, null)),
        React.createElement(Menu, __assign({ anchorOrigin: {
                horizontal: 'left',
                vertical: 'bottom',
            }, transformOrigin: {
                horizontal: 'left',
                vertical: 'top',
            }, onClose: toggleIsMenuOpen }, MenuProps, { MenuListProps: {
                id: menuId,
                'aria-labelledby': "button-".concat(menuId),
            }, anchorEl: buttonRef.current, open: isMenuOpen }), breadcrumbsMenuItems.map(function (item, idx) { return (React.createElement(MenuItem, __assign({ button: true }, MenuItemProps, { value: item.label, key: idx, onClick: function () { return handleOnClick(item); } }), item.label)); }))));
};
export default BreadcrumbsMenu;
//# sourceMappingURL=BreadcrumbsMenu.js.map